import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargesCycle } from '../../models/charges-cycle.model';
import { ChargesCycleService } from '../../services/charges-cycle.service';

@Component({
  selector: 'app-charge-cycle-modal',
  templateUrl: './charge-cycle-modal.component.html',
  styleUrl: './charge-cycle-modal.component.scss'
})
export class ChargeCycleModalComponent implements OnInit {

  @Input() neighborhoodId: string = '';
  @Input() chargesCycle?: ChargesCycle;

  public cutoffDay: number = 1;
  public maxPaymentDay: number = 1;

  constructor(
    public activeModal: NgbActiveModal,
    public chargesCycleService: ChargesCycleService,
  ) {}

  ngOnInit(): void {
    if (this.chargesCycle) {
      this.cutoffDay = this.chargesCycle.cutoffDay;
      this.maxPaymentDay = this.chargesCycle.maxPaymentDay;
    }
  }

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async create(): Promise<void> {
    const flag = await this.chargesCycleService.create(
      this.neighborhoodId,
      { cutoffDay: this.cutoffDay, maxPaymentDay: this.maxPaymentDay }
    );

    if (flag) {
      this.activeModal.close();
    }
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update(): Promise<void> {
    const flag = await this.chargesCycleService.update(
      this.chargesCycle!.chargesCycleId,
      { cutoffDay: this.cutoffDay, maxPaymentDay: this.maxPaymentDay },
      this.neighborhoodId
    );

    if (flag) {
      this.activeModal.close();
    }
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit(): Promise<void> {
    if (this.chargesCycle) {
      await this.update();
    } else {
      await this.create();
    }
  }

}
